import React from 'react';

export const Footer = () => {
  return (
    <footer>
      <span>Brushfire Volunteer App</span>
      <br />
      <span>By: William Pei Yuan</span>
    </footer>
  );
};
